// :cow: Cosmose CONFIDENTIAL :iso:
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Store } from '@ngrx/store';
import { userRestored } from '@coa/app/auth/store/auth.actions';
import { Observable } from 'rxjs';
import { AppConfig } from '@coa/app/core/config/appConfig';
import { PreviousUrlService } from '@coa/app/libs/services/previous-url.service';

@Injectable({
  providedIn: 'root',
})
export class HomeGuardService implements CanActivate {

  constructor(
    private store$: Store,
    private previousUrlService: PreviousUrlService,
    private router: Router) {
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    const accessToken = localStorage.getItem(AppConfig.accessToken) || '';
    const refreshToken = localStorage.getItem(AppConfig.refreshToken) || '';
    if (accessToken) {
      this.store$.dispatch(userRestored({accessToken, refreshToken}));
      return true;
    } else {
      this.previousUrlService.previousUrl = state.url;
      this.router.navigate(['login']);
      return false;
    }
  }

}
